import { render, staticRenderFns } from "./benefits-modal.vue?vue&type=template&id=12e2e78c"
import script from "./benefits-modal.vue?vue&type=script&lang=js"
export * from "./benefits-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports